import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  return (
    <div className="bg-gradient-to-br from-primary to-primary/80 rounded-xl p-8 lg:p-12 text-center text-primary-foreground">
      <div className="max-w-3xl mx-auto">
        {/* Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-6">
          <Icon name="Rocket" size={32} className="text-primary-foreground" />
        </div>

        {/* Heading */}
        <h2 className="font-headline font-bold text-3xl lg:text-4xl mb-4">
          Ready to Transform Your Project?
        </h2>

        {/* Description */}
        <p className="text-xl text-primary-foreground/90 mb-8 leading-relaxed">
          Join hundreds of successful clients who've streamlined their construction journey with Nirmitee's expert guidance and smart tools.
        </p>

        {/* Benefits */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="Clock" size={16} className="text-primary-foreground" />
            </div>
            <span className="text-primary-foreground/90">Save 40-60% Time</span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="TrendingDown" size={16} className="text-primary-foreground" />
            </div>
            <span className="text-primary-foreground/90">Reduce Costs by ₹5-15L</span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="Shield" size={16} className="text-primary-foreground" />
            </div>
            <span className="text-primary-foreground/90">100% Approval Success</span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            variant="secondary"
            size="lg"
            iconName="Calendar"
            iconPosition="left"
            className="bg-white text-primary hover:bg-white/90"
            onClick={() => window.dispatchEvent(new Event('open-consultation-modal'))}
          >
            Book Free Consultation
          </Button>
          <Button
            variant="outline"
            size="lg"
            iconName="Calculator"
            iconPosition="left"
            className="border-white text-white hover:bg-white hover:text-primary"
          >
            Try FSI Calculator
          </Button>
        </div>

        {/* Trust Indicators */}
        <div className="flex items-center justify-center space-x-8 mt-8 pt-8 border-t border-white/20">
          <div className="text-center">
            <p className="text-2xl font-bold text-primary-foreground">500+</p>
            <p className="text-sm text-primary-foreground/80">Projects Completed</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-primary-foreground">4.9/5</p>
            <p className="text-sm text-primary-foreground/80">Client Rating</p>
          </div>
          <div className="text-center">
            <p className="text-2xl font-bold text-primary-foreground">₹50Cr+</p>
            <p className="text-sm text-primary-foreground/80">Total Savings</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;